import { useFindAssetIdForWorkspace } from '@gripp/shared-logic';
import {
  LoadingIndicator,
  SlideAction,
  SlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../../assets/assetRouteContext';
import { AssetCard } from '../../assets/components/assetCard';
import { AssetFilters } from '../../assets/components/assetFilters';
import { EditAssetComponent } from '../../assets/components/edit';
import EditGroup from '../../assets/components/editGroup';
import { HeaderResetButton } from '../../shared/components/headerResetButton';

export const WorkspaceEdit = () => {
  const { workspaceId = '' } = useParams();
  const navigate = useNavigate();
  const { assetId, isLoading } = useFindAssetIdForWorkspace(workspaceId);
  const [selectedGroups, setSelectedGroups] = useState<
    Array<{ id: string; name: string }>
  >([]);
  const [isGroupsPanelOpen, setIsGroupsPanelOpen] = useState(false);
  const resetGroupsRef = useRef<(() => void) | undefined>(undefined);

  const basePath = `/workspaces/${workspaceId}`;
  const routeContext = {
    basePath,
    listPath: '/workspaces',
    isWorkspaceMode: true,
  };

  const leftColumn = {
    title: 'admin.menu.workspaces',
    mainComponent: isLoading ? (
      <LoadingIndicator />
    ) : assetId ? (
      <AssetRouteProvider value={routeContext}>
        <AssetCard assetId={assetId} />
      </AssetRouteProvider>
    ) : null,
    headerComponent:
      !isLoading && assetId ? (
        <AssetRouteProvider value={routeContext}>
          <AssetFilters assetId={assetId} />
        </AssetRouteProvider>
      ) : null,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate(basePath);
    },
  };

  const rightColumn = {
    title: 'workspace.editTitle',
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => navigate(basePath),
    mainComponent: isLoading ? (
      <LoadingIndicator />
    ) : assetId ? (
      <AssetRouteProvider value={routeContext}>
        <EditAssetComponent
          assetId={assetId}
          selectedGroups={selectedGroups}
          onGroupsChange={setSelectedGroups}
          onOpenGroupEditor={() => setIsGroupsPanelOpen(true)}
        />
      </AssetRouteProvider>
    ) : null,
    disableScroll: true,
  };

  const thirdColumn = isGroupsPanelOpen
    ? {
        title: 'asset.groups',
        mainComponent: isLoading ? (
          <LoadingIndicator />
        ) : assetId ? (
          <EditGroup
            assetId={assetId}
            selectedGroups={selectedGroups}
            onGroupsChange={setSelectedGroups}
            resetRef={resetGroupsRef}
          />
        ) : null,
        headerComponent: (
          <View style={styles.headerResetButton}>
            <HeaderResetButton onReset={() => resetGroupsRef.current?.()} />
          </View>
        ),
        showBackButton: true,
        onBackButtonPress: () => setIsGroupsPanelOpen(false),
        disableScroll: true,
      }
    : undefined;

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      thirdColumn={thirdColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const styles = StyleSheet.create({
  headerResetButton: {
    marginRight: 8,
  },
});
